import GoogleWellBeing from "@/assets/media/img/GoogleWellBeing.webp";

import GoogleCalendar from "@/assets/media/img/GoogleCalendar.png";

import GoogleContacts from "@/assets/media/img/GoogleContacts.png";

import GooglePhotos from "@/assets/media/img/GooglePhotos.webp";

import GoogleSheets from "@/assets/media/img/GoogleSheets.webp";

import GoogleGmail from "@/assets/media/img/GoogleGmail.webp";

import GoogleTasks from "@/assets/media/img/GoogleTasks.png";

import GoogleEarth from "@/assets/media/img/GoogleEarth.png";

import GoogleMeet from "@/assets/media/img/GoogleMeet.webp";

import GoogleHome from "@/assets/media/img/GoogleHome.webp";

import GoogleDocs from "@/assets/media/img/GoogleDocs.webp";

import GoogleKeep from "@/assets/media/img/GoogleKeep.png";

export const otherApps = [
    {
        link: '/calendar',
        title: 'Calendar',
        img: GoogleCalendar
    },
    {
        link: '/contacts',
        title: 'Contacts',
        img: GoogleContacts
    },
    {
        link: '/keep',
        title: 'Keep',
        img: GoogleKeep
    },
    {
        link: '/keep',
        title: 'Tasks',
        img: GoogleTasks
    },
    {
        link: '/',
        title: 'Earth',
        img: GoogleEarth
    },
    {
        link: '/',
        title: 'Meet',
        img: GoogleMeet
    },
    {
        link: '/',
        title: 'Photos',
        img: GooglePhotos
    },
    {
        link: '/',
        title: 'Gmail',
        img: GoogleGmail
    },
    {
        link: '/',
        title: 'Home',
        img: GoogleHome
    },
    {
        link: '/',
        title: 'WellBeing',
        img: GoogleWellBeing
    },
    {
        link: '/',
        title: 'Docs',
        img: GoogleDocs
    },
    {
        link: '/',
        title: 'Sheets',
        img: GoogleSheets
    },
]